export default "__VITE_ASSET__BGuxyqJ4__"